
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import Grid from '../../Grid';
import GridItem from '../../GridItem';
import Button from '../../Button';
import UserInput from '../../UserInput';
import Checkbox from '../../CheckboxField';

import styles, { mainCls } from '../style';
import wrapText from '../../Login/Wraptext';

const useStyles = createStyle(styles);

const propTypes = {
  device: PropTypes.string,
  currentUrl: PropTypes.string,
  mobileOs: PropTypes.string,
  portalDomain: PropTypes.string,
  accountDomain: PropTypes.string,
  authBasePrefix: PropTypes.string,
  logIn: PropTypes.func,
  onLogInComplete: PropTypes.func,
  postLoginAction: PropTypes.func,
  cookiesConfig: PropTypes.object,
  emailDisabled: PropTypes.bool,
  email: PropTypes.string,
};
const defaultProps = {
  device: null,
  currentUrl: '/',
  mobileOs: null,
  portalDomain: 'https://www.casa.it',
  accountDomain: 'https://www.casa.it',
  authBasePrefix: '/my',
  logIn: null,
  onLogInComplete: null,
  postLoginAction: null,
  cookiesConfig: {},
  emailDisabled: false,
  email: '',
};

const RegisterSilentlyInterface = ({
  device,
  mobileOs,
  currentUrl,
  portalDomain,
  accountDomain,
  storeRegistrationData,
  validateRegistrationData,
  removeError,
  doRegistration,
  messageRegistrationError,
  registrationError,
  registeringIn,
  validationErrors,
  setConsent,
  consent,
  emailDisabled,
  email
}) => {

  // const accountDomain = "http://localhost:3002" // DA TOGLIERE
  const isDesktop = device === 'desktop';

  const cls = useStyles();
  const baseCssClass = mainCls;

  const mycasaCssClass = `${baseCssClass}__mycasa`;
  const ctnClass = makeClassName([
    cls[mainCls],
    'tp-a--c',
  ]);

  const infosCls = makeClassName([
    cls[`${mainCls}__infos`],
    'mb--m',
    'tp-w--s',
    'tp-s--s',
  ]);

  const clsRegisterButton = makeClassName([
    cls[mainCls],
    `${mainCls}__form__btn`
  ]);

  const clsWrapInputDisabled = makeClassName([
    `${mainCls}__form__wrap_inpt`,
    'tp-w--m', 
    'tp-s--l', 
    'tp-a--l', 
    'pb--s', 
    'pt--s',
  ])

  const clsInputDisabled = makeClassName([
    `${mainCls}__form__inpt_disabled`,
    'tp-w--l',
    'tp-s--l',
    'tp-a--l',
    'c-txt--f0'  
  ]);

  const errorToShowPsw = validationErrors.indexOf('password') > -1 ? 'Password non valida' : '';

  const formWithEmail = () => {
    return (
      <section className="m--s">
        <p className={clsWrapInputDisabled} type="email" name="email" disabled >Email: 
        <input className={clsInputDisabled} disabled name="email" value={email} type="email" id="email" /> </p>
        <p className="tp-w--m tp-s--l tp-a--l pb--s pt--s" >Scegli Password</p>
        <UserInput
          type="password"
          name="password"
          className={`${mycasaCssClass}__input`}
          placeholder="Inserisci la password"
          onChange={storeRegistrationData}
          onBlur={validateRegistrationData}
          onFocus={removeError}
          error={errorToShowPsw}
          errorMsg={!registrationError && errorToShowPsw}
        />
        <UserInput
          type="password"
          name="confirmPassword"
          className={`${mycasaCssClass}__input`}
          placeholder="Reinserisci la password"
          onChange={storeRegistrationData}
          onBlur={validateRegistrationData}
          onFocus={removeError}
          error={validationErrors.indexOf('confirmPassword') > -1}
          errorMsg={!registrationError && 'Le password non coincidono'}
        />
        <p className={infosCls}>
          Usa una password da 8 a 30 caratteri con almeno una lettera maiuscola, una lettera minuscola e un numero.
        </p>
        {
          messageRegistrationError && <p className={`${baseCssClass}__mycasa__registererror mb--m tp-s--xs tp-w--m`}>{messageRegistrationError}</p>
        }
        <Grid direction="column" className='tp-w--s tp-s--s mt--m mb--m'>
          <GridItem className={infosCls}>
            <p>
              <>Ho letto l&#39;informativa sul {wrapText('a', 'trattamento dei dati personali', {
                target: 'blank',
                rel: 'nofollow noopener noreferrer',
                href: 'https://www.casa.it/casait/privacy/',
                title: 'Informativa privacy per gli utenti di Casa.it',
                className: cls[`${mainCls}__form__privacy--a`],
              })}.
              </>
              <>e i {wrapText('a', 'termini e condizioni di servizio.', {
                target: 'blank',
                rel: 'nofollow noopener noreferrer',
                href: 'https://www.casa.it/casait/termini-condizioni-mycasa/',
                title: 'Termini e condizioni utili per gli utenti di Casa.it',
                className: cls[`${mainCls}__form__privacy--a`],
              })}.
              </>

            </p>
          </GridItem>
          <Checkbox
            className={`${mainCls}__checkbox`}
            key={`checkbox_consent`}
            device={device}
            value={consent}
            label="Autorizzo ad inviarmi comunicazioni, informazioni ed offerte commerciali anche di vostri partner."
            onChange={setConsent}
          />
        </Grid>

        <Button
          className={clsRegisterButton}
          id="register__captcha"
          action={doRegistration}
          loading={registeringIn}>
          Accedi
        </Button>
        {/* <Grid
          direction="column"
          justify="center"
          align="center"
          className={`${cls[`${mainCls}__copied`]}${hideCopiedFB ? ' hide' : ''}${showCopiedFB ? ' show' : ''} tp-s--l tp-w--m c-txt--w`}
        >
          <Icon name={Link} className="mb--s" width="34px" height="34px" />
          Link copiato
        </Grid> */}

      </section>
    )

  }


  return (

    <Grid
      direction="column"
      className={ctnClass}
    >
      {formWithEmail()}

    </Grid>

  );
};
RegisterSilentlyInterface.propTypes = propTypes;
RegisterSilentlyInterface.defaultProps = defaultProps;
export default RegisterSilentlyInterface;